export default {
    //GET
    getContactInfo: 'contact/{contact_id}',
};
